(function ($) {
    $(document).ready(function () {

        function dataDel(data) {
            data.on('click', function () {
                var delDataInx = $(this).attr("data-index");
                var delDataType = $(this).attr("filter-data-type");
                var delDataVal = $(this).attr("value");
                var d_list_alpha = $(this).attr("list_alpha");
                if ($('.filters-block.research .author-name ul li[value=' + delDataVal + ']').hasClass('selected')) {
                    $('.filters-block.research .author-name ul li[value=' + delDataVal + ']').trigger('click');
                }

                // $(".filters-block .filter-wrapper .filter-dropdown li").each(function () {
                //     let delValInx = $(this).attr("data-index");
                //     let filDataType = $(this).parent().attr("filter-data-type");
                //     if (delValInx == delDataInx && delDataType == filDataType) {
                //         $(this).removeClass('selected');

                //         if ($('.filters-block.fellow').length > 0) {
                //             var we_len = $(this).parents(".filter-dropdown").find('li[list_alpha=' + d_list_alpha + '].selected').length;
                //             if (we_len === 0) {
                //                 $(this).parents(".filter-dropdown").find('.alphabets-inner li[value=' + d_list_alpha + '].selected').removeClass('selected');
                //             }

                //             var selectedItems = $(this).parents(".filter-dropdown").find(".we-drop li.selected").length;
                //         } else {
                //             var selectedItems = $(this).parents(".filter-dropdown").find("li.selected").length;
                //         }
                //         $(this).parents(".filter-dropdown").find(".filter p").html(selectedItems + " Topics Selected").css("color", "#000");
                //         if (selectedItems == 0) {
                //             $(this).parents(".filter-dropdown").find(".filter p").html("Select from the list...").css("color", "#B9B9B9");
                //         }
                //     }
                // });

                $.each($(".filters-block .form-select option"), function () {
                    let delOptVal = $(this).attr("value");
                    if (delDataVal == delOptVal) {
                        $(this).removeAttr("selected");
                    }
                });

                $(this).remove();
                if ($('.filters-block .filter-data .outer-wrapper span').length < 8) {
                    if ($('.filters-block.fellow .filter-data .outer-wrapper').hasClass('slick-initialized')) {
                        $('.filters-block.fellow .filter-data .outer-wrapper').slick('unslick');
                    }
                }

                const dataWidth1 = $('.filters-block .filter-data .outer-wrapper').width();
                $(".filters-block .filter-data .outer-wrapper").css('width', 'initial');
                var dataLen = $('.filters-block .filter-data .outer-wrapper span.filter-tag').length;
                $('.filters-block .filter-data .total-data').html('<span>' + "+" + dataLen + '</span>');
                if ($('.filters-block .filter-data').width() - 60 > dataWidth1) {
                    $('.filters-block .filter-data .total-data').html('');
                }

                if (dataLen <= 0) {
                    $('.filters-block .selected-data').hide();
                    $('.filters-block .filter-wrapper .filter-title span').hide();
                    $('.filter-content').show();
                    $(".filters-block .total-data").html(" ");
                }
                if ($(".filters-block .outer-wrapper").hasClass("slick-initialized")) {
                    $(".filters-block .total-data").html(" ");
                    if (dataLen <= 0) {
                        $(".filters-block .outer-wrapper.slick-initialized").slick('unslick').removeClass("show-all").html(" ");
                    }
                }

                // Fellow filter list unselect
                $('.filters-block.fellow .expertise li').each(function () {
                    let delOptVal = $(this).attr("value");
                    if (delDataVal === delOptVal) {
                        $(this).removeClass("selected");
                    }
                });

                // Fellow Typr filter list unselect
                $('.filters-block.fellow .fellow-type li').each(function () {
                    let delOptVal = $(this).attr("value");
                    if (delDataVal === delOptVal) {
                        $(this).removeClass("selected");
                    }
                });

                $(".filters-block .form-actions .form-submit").trigger("click");

                if ($('.filters-block').length > 0 && !$(".filters-block.fellow").length > 0) {
                    //removeUrl();
                    listValue();
                }
            });
            return false;
        }


        // Research Filter
        function research_filter() {
            if ($('.filters-block.research').length > 0) {
                // Update Topic Text
                $(".filters-block.research .form-item-field-research-topic-target-id select option").each(function (index) {
                    var text = $(this).text().replace(new RegExp('-', 'g'), "");
                    var val = $(this).val();
                    $('.filters-block.research .topic').append('<li></li>');
                    setTimeout(function () {
                        $('.filters-block.research .topic li:eq(' + (index) + ')').html(text).attr('value', val);
                    }, 300);
                });

                // Topic list click event
                $('.filters-block.research .topic li').on("click", function () {
                    var selectedItemVal, itemVal, selectedTxt;
                    itemVal = $(this).attr("value");
                    var itemClass = $(this).attr("class");
                    $(".filters-block.research .form-item-field-research-topic-target-id select option").each(function () {
                        selectedItemVal = $(this).attr("value");
                        selectedTxt = $(this).text();
                        if (itemClass != "selected") {
                            if (itemVal === selectedItemVal) {
                                $(this).attr("selected", "selected");
                            }
                        }
                        else {
                            if (itemVal === selectedItemVal) {
                                $(this).removeAttr("selected");
                            }
                        }
                    });

                    $(".filters-block .form-actions .form-submit").trigger("click");
                });

                // Update Content Type Text
                $(".filters-block.research .form-item-field-research-type-target-id select option").each(function (index) {
                    var text = $(this).text().replace(new RegExp('-', 'g'), "");
                    var val = $(this).val();
                    $('.filters-block.research .content-type').append('<li></li>');
                    setTimeout(function () {
                        $('.filters-block.research .content-type li:eq(' + (index) + ')').html(text).attr('value', val);
                    }, 300);
                });

                // Content Type list click event
                $('.filters-block.research .content-type li').on("click", function () {
                    var selectedItemVal, itemVal, selectedTxt;
                    itemVal = $(this).attr("value");
                    var itemClass = $(this).attr("class");

                    $(".filters-block.research .form-item-field-research-type-target-id select option").each(function () {
                        selectedItemVal = $(this).attr("value");
                        selectedTxt = $(this).text();
                        if (itemClass != "selected") {
                            if (itemVal === selectedItemVal) {
                                $(this).attr("selected", "selected");
                            }
                        }
                        else {
                            if (itemVal === selectedItemVal) {
                                $(this).removeAttr("selected");
                            }
                        }
                    });

                    $(".filters-block .form-actions .form-submit").trigger("click");
                });


                // Update key-focus Text
                $(".filters-block.research .form-item-field-key-focus-areas-target-id select option").each(function (index) {
                    var text = $(this).text().replace(new RegExp('-', 'g'), "");
                    var val = $(this).val();
                    $('.filters-block.research .key-focus').append('<li></li>');
                    setTimeout(function () {
                        $('.filters-block.research .key-focus li:eq(' + (index) + ')').html(text).attr('value', val);
                    }, 300);
                });

                // Content key-focus click event
                $('.filters-block.research .key-focus li').on("click", function () {
                    var selectedItemVal, itemVal, selectedTxt;
                    itemVal = $(this).attr("value");
                    var itemClass = $(this).attr("class");

                    $(".filters-block.research .form-item-field-key-focus-areas-target-id select option").each(function () {
                        selectedItemVal = $(this).attr("value");
                        selectedTxt = $(this).text();
                        if (itemClass != "selected") {
                            if (itemVal === selectedItemVal) {
                                $(this).attr("selected", "selected");
                            }
                        }
                        else {
                            if (itemVal === selectedItemVal) {
                                $(this).removeAttr("selected");
                            }
                        }
                    });

                    $(".filters-block .form-actions .form-submit").trigger("click");
                });

                // Update Publication Text
                $(".filters-block.research .form-item-field-ref-publication-target-id-verf select option").each(function (index) {
                    var text = $(this).text().replace(new RegExp('-', 'g'), "");
                    var val = $(this).val();
                    $('.filters-block.research .publication').append('<li></li>');
                    setTimeout(function () {
                        $('.filters-block.research .publication li:eq(' + (index) + ')').html(text).attr('value', val);
                    }, 300);
                });

                // Update Publication Text For Event Page
                $(".filters-block.events .form-item-field-publication-target-id-verf select option").each(function (index) {
                    var text = $(this).text().replace(new RegExp('-', 'g'), "");
                    var val = $(this).val();
                    $('.filters-block.events .publication').append('<li></li>');
                    setTimeout(function () {
                        $('.filters-block.events .publication li:eq(' + (index) + ')').html(text).attr('value', val);
                    }, 300);
                });

                // Content publication click event
                $('.filters-block.research .publication li').on("click", function () {
                    var selectedItemVal, itemVal, selectedTxt;
                    itemVal = $(this).attr("value");
                    var itemClass = $(this).attr("class");

                    $(".filters-block.research .form-item-field-ref-publication-target-id-verf select option").each(function () {
                        selectedItemVal = $(this).attr("value");
                        selectedTxt = $(this).text();
                        if (itemClass != "selected") {
                            if (itemVal === selectedItemVal) {
                                $(this).attr("selected", "selected");
                            }
                        }
                        else {
                            if (itemVal === selectedItemVal) {
                                $(this).removeAttr("selected");
                            }
                        }
                    });

                    // Form select for event page
                    $(".filters-block.events .form-item-field-publication-target-id-verf select option").each(function () {
                        selectedItemVal = $(this).attr("value");
                        selectedTxt = $(this).text();
                        if (itemClass != "selected") {
                            if (itemVal === selectedItemVal) {
                                $(this).attr("selected", "selected");
                            }
                        }
                        else {
                            if (itemVal === selectedItemVal) {
                                $(this).removeAttr("selected");
                            }
                        }
                    });

                    $(".filters-block .form-actions .form-submit").trigger("click");
                });

                // Update Region Text
                $(".filters-block.research .form-item-field-tref-region-target-id select option").each(function (index) {
                    var text = $(this).text().replace(new RegExp('-', 'g'), "");
                    var val = $(this).val();
                    $('.filters-block.research .region').append('<li></li>');
                    setTimeout(function () {
                        $('.filters-block.research .region li:eq(' + (index) + ')').html(text).attr('value', val);
                    }, 300);
                });

                // Content Region click event
                $('.filters-block.research .region li').on("click", function () {
                    var selectedItemVal, itemVal, selectedTxt;
                    itemVal = $(this).attr("value");
                    var itemClass = $(this).attr("class");

                    $(".filters-block.research .form-item-field-tref-region-target-id select option").each(function () {
                        selectedItemVal = $(this).attr("value");
                        selectedTxt = $(this).text();
                        if (itemClass != "selected") {
                            if (itemVal === selectedItemVal) {
                                $(this).attr("selected", "selected");
                            }
                        }
                        else {
                            if (itemVal === selectedItemVal) {
                                $(this).removeAttr("selected");
                            }
                        }
                    });

                    $(".filters-block .form-actions .form-submit").trigger("click");
                });

                // Update Team Text
                $(".filters-block.research .form-item-field-ref-group-target-id-verf select option").each(function (index) {
                    var text = $(this).text().replace(new RegExp('-', 'g'), "");
                    var val = $(this).val();
                    $('.filters-block.research .team').append('<li></li>');
                    setTimeout(function () {
                        $('.filters-block.research .team li:eq(' + (index) + ')').html(text).attr('value', val);
                    }, 300);
                });

                // Update Team Text For Event Page
                $(".filters-block.events .form-item-field-research-team-target-id-verf select option").each(function (index) {
                    var text = $(this).text().replace(new RegExp('-', 'g'), "");
                    var val = $(this).val();
                    $('.filters-block.events .team').append('<li></li>');
                    setTimeout(function () {
                        $('.filters-block.events .team li:eq(' + (index) + ')').html(text).attr('value', val);
                    }, 300);
                });

                // Content Region click event
                $('.filters-block.research .team li').on("click", function () {
                    var selectedItemVal, itemVal, selectedTxt;
                    itemVal = $(this).attr("value");
                    var itemClass = $(this).attr("class");

                    $(".filters-block.research .form-item-field-ref-group-target-id-verf select option").each(function () {
                        selectedItemVal = $(this).attr("value");
                        selectedTxt = $(this).text();
                        if (itemClass != "selected") {
                            if (itemVal === selectedItemVal) {
                                $(this).attr("selected", "selected");
                            }
                        }
                        else {
                            if (itemVal === selectedItemVal) {
                                $(this).removeAttr("selected");
                            }
                        }
                    });

                    // Form select for event page
                    $(".filters-block.events .form-item-field-research-team-target-id-verf select option").each(function () {
                        selectedItemVal = $(this).attr("value");
                        selectedTxt = $(this).text();
                        if (itemClass != "selected") {
                            if (itemVal === selectedItemVal) {
                                $(this).attr("selected", "selected");
                            }
                        }
                        else {
                            if (itemVal === selectedItemVal) {
                                $(this).removeAttr("selected");
                            }
                        }
                    });

                    $(".filters-block .form-actions .form-submit").trigger("click");
                });

                // Author Filter
                function author() {
                    var prev_alp = "weqwe";
                    $('.filters-block.research .author-name ul').empty();
                    $(".filters-block.research .form-item-field-authors-target-id-verf select option").each(function () {
                        var text = $(this).text();
                        var val = text.charAt(0);
                        $(this).attr('alphabet', val);
                        if (val != prev_alp && val != " ") {
                            prev_alp = val;
                            $('.filters-block.research .author-name ul').append("<li value=" + val + ">" + val + "</li>");
                        }
                    });
                }

                //author();

                // Author Filter click event
                $('.filters-block.research .author-name ul li').on("click", function () {
                    $(this).parent().addClass('clicked');
                    var selectedItemVal, itemVal, selectedTxt;
                    itemVal = $(this).attr("value");
                    var itemClass = $(this).attr("class");

                    $(".filters-block.research .form-item-field-authors-target-id-verf select option").each(function () {
                        selectedItemVal = $(this).attr("alphabet");
                        selectedTxt = $(this).text();
                        if (itemClass != "selected") {
                            if (itemVal === selectedItemVal) {
                                $(this).attr("selected", "selected");
                            }
                        }
                        else {
                            if (itemVal === selectedItemVal) {
                                $(this).removeAttr("selected");
                            }
                        }
                    });

                    $(".filters-block .form-actions .form-submit").trigger("click");
                });

                // Sort-view Functionality
                $('.filters-block .filter-wrapper .sort-view ul li').on('click', function () {
                    var value = $(this).attr('data-value');
                    var value2 = $('.filters-block .views-exposed-form .form-item-sort-order select').val();
                    if (value !== value2) {
                        $('.filters-block .views-exposed-form .form-item-sort-order select').val(value).trigger('change');
                        $('.filters-block .form-actions .form-submit').trigger('click');
                    }
                })
            }
        }

        // News Filter
        function news_Filter() {
            // Update Topic Text
            $(".filters-block.news .form-item-field-tref-topic-target-id #edit-field-tref-topic-target-id option").each(function (index) {
                var text = $(this).text().replace(new RegExp('-', 'g'), "");
                var val = $(this).val();
                $('.filters-block.news .topic').append('<li></li>');
                setTimeout(function () {
                    $('.filters-block.news .topic li:eq(' + (index) + ')').html(text).attr('value', val);
                }, 300);
            });

            // Topic list click event
            $('.filters-block.news .topic li').on("click", function () {
                var selectedItemVal, itemVal, selectedTxt;
                itemVal = $(this).attr("value");
                var itemClass = $(this).attr("class");
                $(".views-exposed-form .form-item-field-tref-topic-target-id select option").each(function () {
                    selectedItemVal = $(this).attr("value");
                    selectedTxt = $(this).text();
                    if (itemClass != "selected") {
                        if (itemVal === selectedItemVal) {
                            $(this).attr("selected", "selected");
                        }
                    }
                    else {
                        if (itemVal === selectedItemVal) {
                            $(this).removeAttr("selected");
                        }
                    }
                });

                $(".filters-block .form-actions .form-submit").trigger("click");
            });

            // Update Team Text
            $(".filters-block.news .form-item-field-research-team-target-id-verf select option").each(function (index) {
                var text = $(this).text().replace(new RegExp('-', 'g'), "");
                var val = $(this).val();
                $('.filters-block.news .team').append('<li></li>');
                setTimeout(function () {
                    $('.filters-block.news .team li:eq(' + (index) + ')').html(text).attr('value', val);
                }, 300);
            });

            // Team list click event
            $('.filters-block.news .team li').on("click", function () {
                var selectedItemVal, itemVal, selectedTxt;
                itemVal = $(this).attr("value");
                var itemClass = $(this).attr("class");
                $(".views-exposed-form .form-item-field-research-team-target-id-verf select option").each(function () {
                    selectedItemVal = $(this).attr("value");
                    selectedTxt = $(this).text();
                    if (itemClass != "selected") {
                        if (itemVal === selectedItemVal) {
                            $(this).attr("selected", "selected");
                        }
                    }
                    else {
                        if (itemVal === selectedItemVal) {
                            $(this).removeAttr("selected");
                        }
                    }
                });

                $(".filters-block .form-actions .form-submit").trigger("click");
            });

            // News Press click event
            $('.filters-block.news .news-press li').on("click", function () {
                var selectedItemVal, itemVal, selectedTxt;
                itemVal = $(this).attr("value");
                var itemClass = $(this).attr("class");
                $(".views-exposed-form .form-item-field-news-type-value select option").each(function () {
                    selectedItemVal = $(this).attr("value");
                    selectedTxt = $(this).text();
                    if (itemClass != "selected") {
                        if (itemVal === selectedItemVal) {
                            $(this).attr("selected", "selected");
                        }
                    }
                    else {
                        if (itemVal === selectedItemVal) {
                            $(this).removeAttr("selected");
                        }
                    }
                });

                $(".filters-block .form-actions .form-submit").trigger("click");
            });

        }

        // Events Author Filter

        function update_author_events() {
            if ($('.filters-block.events').length > 0) {
                var prev_alp = "wed";
                $('.filters-block.events .author-name ul').empty();
                $(".filters-block.events .form-item-field-contributors-target-id-verf select option").each(function () {
                    var trimSpace = $.trim($(this).text());
                    $(this).text(trimSpace);
                    var text = $(this).text();
                    var val = text.charAt(0);
                    if (val != prev_alp && val != " ") {
                        prev_alp = val;
                        $('.filters-block.events .author-name ul').append("<li value=" + val + ">" + val + "</li>");
                    }
                });

                // Author Filter click event
                $('.filters-block.events .author-name ul li').on("click", function () {
                    var selectedItemVal, itemVal, selectedTxt;
                    itemVal = $(this).attr("value");
                    var itemClass = $(this).attr("class");

                    $(".filters-block.events .form-item-field-contributors-target-id-verf select option").each(function () {
                        selectedItemVal = $(this).attr("alphabet");
                        selectedTxt = $(this).text();
                        if (itemClass != "selected") {
                            if (itemVal === selectedItemVal) {
                                $(this).attr("selected", "selected");
                            }
                        }
                        else {
                            if (itemVal === selectedItemVal) {
                                $(this).removeAttr("selected");
                            }
                        }
                    });

                    $(".filters-block .form-actions .form-submit").trigger("click");
                });
            }
        }


        // Update first latter in drupal form
        function auth_filter() {
            // Events author first latter update
            if ($('.filters-block.events').length > 0) {
                function author_events() {
                    $(".filters-block.events .form-item-field-contributors-target-id-verf select option").each(function () {
                        var trimSpace = $.trim($(this).text());
                        $(this).text(trimSpace);
                        var text = $(this).text();
                        var val = text.charAt(0);
                        $(this).attr('alphabet', val);
                    });
                }

                author_events();
            }

            // Research author first latter update
            if ($('.filters-block.research').length > 0) {
                function author_Research() {
                    $(".filters-block.research .form-item-field-authors-target-id-verf select option").each(function () {
                        var text = $(this).text();
                        var val = text.charAt(0);
                        $(this).attr('alphabet', val);
                    });
                }

                author_Research();
            }

        }

        research_filter();
        news_Filter();
        //update_author_events();
        auth_filter();

        // For News & Press, Events
        $(window).on('load', function () {
            if ($('.filters-block .team').length > 0) {
                // Functionality for tag name
                var page_url = window.location.href;
                if (page_url.indexOf('/') > -1) {
                    var array1 = page_url.split('?');
                    var string1 = array1[1];
                    var string3 = array1[1];
                    if (array1[1]) {
                        string1 = string1.split('=')[0];
                        var string2 = string3.split('=')[1];
                        if (string1 === "research_team") {
                            $('.filters-block .team li[value=' + string2 + ']').trigger("click");
                            $(".filters-block .team").parents('.filter-dropdown').find(".filter p").html(1 + " Topics Selected").css("color", "#000");
                        }
                        // if (string1 != "issue") {
                        //     setTimeout(function () {
                        //         var content = $('.filters-block');
                        //        // $('html, body').animate({'scrollTop': $(content).offset().top}, 800, 'swing');
                        //     }, 1500);
                        // }
                    }
                }
            }
            if ($('.filters-block').length > 0) {
                if ($('.filters-block .filter-wrapper .filter-content .wrapper .filter-dropdown').length < 4) {
                    $('.filters-block .filter-wrapper .filter-content .btn-wrap').hide();
                }
            }
        });


        if ($('.filters-block').length > 0) {
            // pager found from drupal pagination display none
            if ($(".filters-block .views-element-container").length > 0) {
                $(".filters-block .result--wrapper .status").css("opacity", "0");
            }

            // if ($(".filters-block .views-element-container nav.pager").length > 0) {
            //     $(".filters-block nav.pager").css("display", "none");
            // }


            // Selection of filter tag through data-type and data-index
            if (!$('.filters-block').hasClass('hoover-press')) {
                $(".filters-block .column-wrapper .col-three p").dotdotdot({
                    height: 100,
                    fallbackToLetter: true,
                    watch: true,
                });
                if (!$(".filters-block").hasClass('hoover-press')) {

                    // $(".filters-block .column-wrapper .col-three h6").dotdotdot({
                    //   height: 24,
                    //   fallbackToLetter: true,
                    //   watch: true,
                    // });
                }
                else {
                    // $(".filters-block .column-wrapper .col-three h6").dotdotdot({
                    //   height: 45,
                    //   fallbackToLetter: true,
                    //   watch: true,
                    // });
                }

            }
            else {
                var thisSec = $(this);
                setLines(thisSec);

            }

            $('.filters-block .filter').each(function () {
                var dataType = $(this).find("span").text().toLowerCase().split(" ").join("-").slice(3);
                $(this).parent().find("ul").attr("filter-data-type", dataType);
            });

            //set value from drupal to filter-items

            $(".filters-block  .filter-items").each(function () {
                $(this).parent().addClass("select-box");
            });

            // get value from search box and apply to filter

            $(".filters-block .filter-dropdown.search button").on("click", function (e) {
                // e.preventDefault();
                var serTxt = $(this).siblings("input").val();
                $(".filters-block .js-form-type-textfield input").val(serTxt);
                $(".filters-block .form-actions .form-submit").trigger("click");

            });

            //pagination

            $(".filters-block .pagination input").on("input keydown keyup mousedown mouseup select contextmenu drop", function () {
                return $(this).val($(this).val().match(/^-?\d*$/));
            });

            $(".filters-block .pagination form").on("submit", function (e) {
                e.preventDefault();
            });


            $(".filters-block .pagination input").on("keyup", function () {
                var keycode = (event.keyCode ? event.keyCode : event.which);
                if (keycode == '13') {
                    $(".filters-block .pagination button").trigger('click');
                }
            });


            function pageNo() {
                if ($(".filters-block .views-element-container nav.pager").length > 0) {

                    $('.filters-block  nav.pager ul li a .visually-hidden').remove();
                    var totalPage = $(".filters-block nav.pager li").find("a").text().match(/\d+/g);

                    $(".filters-block .pagination  .page-no > span").addClass("total-page");

                    $(".filters-block .pagination  .total-page").html('<span>' + "of " + '</span>' + totalPage.length);

                    $(".filters-block .pagination").css("display", "flex");

                    $(".filters-block .pagination .next.active").on("click", function () {
                        $(".filters-block nav.pager a[rel=\"next\"]").trigger("click");
                        var currentPage = $(".filters-block nav.pager li.pager__item.is-active a").text().match(/\d+/g);
                        if (parseInt($(".filters-block .pagination input").val()) != totalPage.length) {
                            $(".filters-block .pagination input").val(parseInt(currentPage) + 1);
                        }
                        if (parseInt($(".filters-block .pagination input").val()) != 1) {
                            $(".filters-block .pagination .prev").addClass("active");
                        }
                        else {
                            $(".filters-block .pagination .prev").removeClass("active")
                        }
                        if (parseInt($(".filters-block .pagination input").val()) == totalPage.length) {
                            $(".filters-block .pagination .next").removeClass("active");
                        }
                        $(".filters-block .pagination .invalid-page").remove();
                    });
                    $(".filters-block .pagination .prev").on("click", function () {
                        $(".filters-block nav.pager a[rel=\"prev\"]").trigger("click");
                        var currentPage = $(".filters-block nav.pager li.pager__item.is-active a").text().match(/\d+/g);
                        if (parseInt($(".filters-block .pagination input").val()) != 1) {
                            $(".filters-block .pagination input").val(parseInt(currentPage) - 1);
                        }
                        if (parseInt($(".filters-block .pagination input").val()) != totalPage.length) {
                            $(".filters-block .pagination .next").addClass("active");
                        }
                        else {
                            $(".filters-block .pagination .next").removeClass("active")
                        }
                        if (parseInt($(".filters-block .pagination input").val()) == 1) {
                            $(".filters-block .pagination .prev").removeClass("active");
                        }
                        $(".filters-block .pagination .invalid-page").remove();
                    });
                }
                else $(".filters-block .pagination:not(.research-pagination)").css("display", "none");
            }

            pageNo();

            $(".filters-block .pagination button").on("click", function (e) {
                e.preventDefault();
                var findPage = parseInt($(".filters-block .pagination input").val());
                var totalPage = $(".filters-block .pagination .total-page").text().match(/\d+/g);
                if ($(".filters-block .pagination input").val() == "") {
                    $(".filters-block .pagination .invalid-page").remove();
                    $(".filters-block .pagination").append('<span class="invalid-page" ' + 'style="color: red; display: block; width: 100%; text-align: center">' + "Please enter valid page number." + '</span>');
                    return false
                }
                if (findPage === 0 || findPage > totalPage) {
                    $(".filters-block .pagination .invalid-page").remove();
                    $(".filters-block .pagination").append('<span class="invalid-page" ' + 'style="color: red; display: block; width: 100%; text-align: center">' + "Invalid page number." + '</span>');
                    return false
                }
                else {
                    $(".filters-block nav.pager li").find("a").each(function () {
                        var str = parseInt($(this).text());
                        if (str === findPage) {
                            $(this).trigger("click");
                        }
                    });

                    $(".filters-block .pagination .invalid-page").remove();
                }
                if (parseInt($(".filters-block .pagination input").val()) > 1) {
                    $(".filters-block .pagination .prev").addClass("active");
                    $(".filters-block .pagination .next").addClass("active");
                }
                else $(".filters-block .pagination .prev").removeClass("active");

                if (parseInt($(".filters-block .pagination input").val()) == 1) {
                    $(".filters-block .pagination .next").addClass("active");
                }
                if (parseInt($(".filters-block .pagination input").val()) == totalPage) {
                    $(".filters-block .pagination .next").removeClass("active");
                }
            });

            $(document).ajaxSuccess(function () {
                pageNo();
                auth_filter();
                $('.filters-block.research .author-name ul').removeClass('clicked');
            });


            $(".filters-block header").html(function () {
                var text = $(this).text().trim().split(" ");
                var first = text.shift();
                return (text.length > 0 ? "<span>" + first + "</span> " : first) + text.join(" ");
            });


            $('.filters-block .filter-wrapper .filter-dropdown li').each(function (i) {
                let filDataType = $(this).parent().attr("filter-data-type");
                $(this).attr("data-index", i);
                $(this).attr("filter-data-type", filDataType);
            });

            // Filter dropdown
            $('.filters-block .filter-wrapper .filter-title span').hide();
            const staticWid = $('.filters-block .filter-data').width() - 60;
            $('.filters-block .selected-data').hide();
            var LiN = $('.filters-block .filter-wrapper .wrapper .filter-dropdown');
            var countDropdown = 0;
            if (!$('.filters-block').hasClass("myhoover-feed")) {
                LiN.each(function () {
                    if (!$(this).hasClass("hide")) {
                        countDropdown = countDropdown + 1;
                        const index = $(this).index();
                        if (countDropdown > 3) {
                            $(this).hide();
                        }
                    } else {
                        $(this).hide();
                    }
                });
            }

            if (LiN.length > 3 && (!$('.filters-block').hasClass("myhoover-feed"))) {
                $('.filters-block .filter-wrapper .wrapper .filter-dropdown', this).eq(2).nextAll().addClass('toggleable');
            }
            //Closing dropdown by clickling anywhere

            $('.filters-block .filter-wrapper .filter-items').on("click", function (e) {
                e.stopPropagation();
            });
            $('.filters-block .filter-wrapper .filter').on('click', function (e) {
                e.stopPropagation();
                //e.preventDefault();

                if ($(this).parent().hasClass('open')) {
                    var selectedItems = $(".filter-dropdown.open li.selected").length;
                    $(".filter-dropdown.open .filter p").html(selectedItems + " Topics Selected").css("color", "#000");
                    if (selectedItems == 0) {
                        $(".filter-dropdown.open .filter p").html("Select from the list...").css("color", "#B9B9B9");
                    }

                    if (!$(this).parent().hasClass("search")) {
                        $(this).parent().removeClass('open');
                    }
                }
                else {
                    var selectedItems = $(".filter-dropdown.open li.selected").length;
                    $(".filter-dropdown.open .filter p").html(selectedItems + " Topics Selected").css("color", "#000");
                    if (selectedItems == 0) {
                        $(".filter-dropdown.open .filter p").html("Select from the list...").css("color", "#B9B9B9");
                    }
                    $(this).parent().siblings().removeClass('open');

                    $(this).parent().addClass('open');


                }
                if ($('.filters-block.fellow .filter-wrapper .wrapper .toggleable').hasClass('open')) {
                    var pos = $('.filters-block.fellow .filter-wrapper .wrapper .toggleable').position();
                    var hgt = $('.filters-block.fellow .filter-wrapper .wrapper .toggleable').outerHeight() + 36;
                    $('.filters-block.fellow .filter-wrapper .wrapper .toggleable').find('.filter-items').css({ 'top': (pos.top + hgt) + "px" });
                }
                if ($(window).width() < 992) {
                    if ($('.filters-block.fellow .filter-wrapper .wrapper .filter-dropdown').hasClass('open')) {
                        var pos1 = $(this).position();
                        var hgt1 = $('.filters-block.fellow .filter-wrapper .wrapper .filter-dropdown').outerHeight();
                        $('.filters-block.fellow .filter-wrapper .wrapper .filter-dropdown').find('.filter-items').css({ 'top': (pos1.top + hgt1) + "px" });

                    }
                    if ($('.filters-block.fellow .filter-wrapper .wrapper .toggleable').eq(1).hasClass('open')) {
                        var pos2 = $('.filters-block.fellow .filter-wrapper .wrapper .toggleable').position();
                        var hgt2 = $('.filters-block.fellow .filter-wrapper .wrapper .toggleable').outerHeight() * 2 + 19;
                        $('.filters-block.fellow .filter-wrapper .wrapper .toggleable').find('.filter-items').css({ 'top': (pos2.top + hgt2) + "px" });

                    }
                }
            });
            $(document).on("click", function () {
                if ($('.filters-block.fellow').length > 0) {
                    var selectedItems = $(".filter-dropdown.open .we-drop li.selected").length;
                } else {
                    var selectedItems = $(".filter-dropdown.open li.selected").length;
                }
                $(".filters-block .filter-dropdown.open .filter p").html(selectedItems + " Topics Selected").css("color", "#000");
                if (selectedItems == 0) {
                    $(".filters-block .filter-dropdown.open .filter p").html("Select from the list...").css("color", "#B9B9B9");
                }
                $(".filters-block .filter-dropdown").removeClass("open");
            });

            // edit filter make sticky

            var stickyNav = $(".sticky-nav"), stickyOffsetTop, stickyH = stickyNav.outerHeight();
            let loginId = $("body").attr('id') == "admin-logged-in" ? true : false
            setTimeout(function () {

                $(window).on('resize scroll', function () {
                    let hdr_h = $('body .header').outerHeight();
                    let stkyTop = loginId ? 200 : (hdr_h + stickyH)
                    stickyOffsetTop = $(".filters-block .filter-wrapper").offset().top - stkyTop;
                    var off_left = $('body .header .nav-logo').offset().left;
                    var edit_wid = $('body .filters-block .filter-wrapper .edit-filter').width();
                    var total = (off_left - edit_wid);
                    var total1 = off_left + 10;
                    var total2 = off_left - 10;
                    var secHeight = $(".filters-block").offset().top + $(".filters-block .filter-wrapper").height() - 225;
                    var scroll = $(window).scrollTop();


                    if (scroll >= stickyOffsetTop) {
                        $(".edit-filter").addClass("fixed");
                        $('.edit-filter').css({
                            'position': 'fixed',
                            'left': +total,
                            'top': '121px !important'

                        });
                        if ($('header').hasClass('off-canvas')) {
                            $('.edit-filter').css({
                                'top': `${loginId ? '276px' : '201px'}`,
                                'transition': 'top 0.3s ease-in-out',
                            });
                        } else {
                            $('.edit-filter').css({
                                'top': `${loginId ? '201px' : '121px'}`,
                                'transition': 'top 0.3s ease-in-out',
                            });
                        }
                        if (stickyNav.length === 0) {
                            $('.edit-filter').css({
                                'top': '128px'
                            });
                        }
                        if (scroll >= secHeight) {
                            $('.edit-filter').css({
                                'position': 'absolute',
                                'left': -64,
                                'top': 'unset',
                                'bottom': 0
                            });

                        }
                        if ($(window).width() < 1600 && $(window).width() > 1399) {
                            if (scroll >= secHeight) {
                                $('.edit-filter').css({
                                    'position': 'absolute',
                                    'left': -48,
                                    'top': 'unset',
                                    'bottom': 0
                                });

                            }
                        }
                        if ($(window).width() < 1270 && $(window).width() > 1199) {
                            if (scroll >= secHeight) {
                                $('.edit-filter').css({
                                    'position': 'absolute',
                                    'left': -48,
                                    'top': 'unset',
                                    'bottom': 0,
                                });

                            }
                        }

                    }
                    else {
                        $('.edit-filter').css({
                            'transition': 'none',
                        });

                        if ($(window).width() >= 1600) {
                            $('.edit-filter').css({
                                'position': 'absolute',
                                'left': -64,
                                'top': '0'
                            });
                        }
                        else {
                            $(".edit-filter").removeClass("fixed");
                            $('.edit-filter').css({
                                'position': 'absolute',
                                'left': -49,
                                'top': '0'
                            });
                        }
                    }
                    if ($(window).width() < 1399 && $(window).width() > 1300) {
                        if (scroll >= stickyOffsetTop) {
                            $(".edit-filter").addClass("fixed");
                            $('.edit-filter').css({
                                'position': 'fixed',
                                'left': +total1,
                                'top': '72px'
                            });

                            if ($('header').hasClass('off-canvas')) {
                                $('.edit-filter').css({
                                    'top': '199px'
                                });
                            }
                            if (scroll >= secHeight) {
                                $('.edit-filter').css({
                                    'position': 'absolute',
                                    'left': -49,
                                    'top': 'unset'
                                });
                            }
                        }
                        else {
                            $(".edit-filter").removeClass("fixed");
                            $('.edit-filter').css({
                                'position': 'absolute',
                                'left': -49,
                                'top': 'unset'
                            });
                        }
                    }

                    if ($(window).width() < 1301 && $(window).width() > 1270) {
                        if (scroll >= stickyOffsetTop) {
                            $(".edit-filter").addClass("fixed");
                            $('.edit-filter').css({
                                'position': 'fixed',
                                'left': +total2,
                                'top': '72px'
                            });
                            if ($('header').hasClass('off-canvas')) {
                                $('.edit-filter').css({
                                    'top': '199px'
                                });
                            }
                            if (scroll >= secHeight) {
                                $('.edit-filter').css({
                                    'position': 'absolute',
                                    'left': -49,
                                    'top': '0'
                                });
                            }
                        }
                        else {
                            $(".edit-filter").removeClass("fixed");
                            $('.edit-filter').css({
                                'position': 'absolute',
                                'left': -49,
                                'top': '0'
                            });
                        }
                    }

                });
            }, 2000);

            // Code for update value in address bar START
            function removeUrl() {
                var href = window.location.origin + window.location.pathname;
                history.pushState({}, null, href);
            }

            function urlUpdate(str) {
                var href = window.location.href;
                var href1 = href.split("?");
                var newitem = href1[0].toString();
                href1.shift();
                var newhref = href1.join(" ");
                newhref = newhref.split("$");

                if (href.includes(str)) {
                    for (var i = 0; i < newhref.length; i++) {
                        if (newhref[i].toString().includes(str)) {
                            newhref.splice(i, 1)
                            newhref.push(str)
                        }
                    }
                    newhref = newhref.join('$')
                    href1 = newitem + '?' + newhref;
                    history.pushState({}, null, href1);
                }
                else {
                    if (href1.length < 1) {
                        history.pushState({}, null, href + '?' + str);
                    } else {
                        history.pushState({}, null, href + '$' + str);
                    }
                }
            }

            function fetchUrl() {
                var href = window.location.href, array = [];
                href = href.split('?');
                href.shift();
                var newhref = href.join(" ");
                newhref = newhref.split("$");
                for (var i = 0; i < newhref.length; i++) {
                    array.push(newhref[i].toString().split('='));
                }

                for (var i = 0; i < array.length; i++) {
                    var item = array[i];

                    if (item[0] === "topic") {
                        var numbersArray = item[1].split(',');
                        for (var j = 0; j < numbersArray.length; j++) {
                            var itemVal, selectedTxt;
                            itemVal = numbersArray[j];
                            $('.filters-block .filter-items .topic li').each(function () {
                                var selectedItemVal;
                                var itemClass = $(this).attr("class");
                                selectedItemVal = $(this).attr("value");
                                if (itemClass != "selected") {
                                    if (itemVal === selectedItemVal) {
                                        $(this).addClass("selected");

                                        if ($('.filters-block.news').length > 0) {
                                            $(".views-exposed-form .form-item-field-tref-topic-target-id select option[value=" + itemVal + "]").attr("selected", "selected");
                                        } else {
                                            $(".views-exposed-form .form-item-field-research-topic-target-id select option[value=" + itemVal + "]").attr("selected", "selected");
                                        }

                                        $('.filters-block .selected-data').show();
                                        let filVal = $(this).clone().html();
                                        let filDataInx = $(this).attr("data-index");
                                        let filDataType = $(this).parent().attr("filter-data-type");
                                        let optionVal = $(this).attr("value");
                                        if (!$(this).parent().hasClass('alphabets-inner')) {
                                            $('.filters-block .filter-data .outer-wrapper').append('<span  filter-data-type = ' + filDataType + ' data-index =' + filDataInx + ' value =' + optionVal + '>' + filVal + '</span>');
                                            $('.filters-block .filter-data .outer-wrapper span').addClass('filter-tag');
                                        }

                                    }
                                }
                            });
                        }
                        var sel_length = $('.filters-block .filter-items .topic li.selected').length;
                        if (sel_length > 0) {
                            $(".filters-block .filter-wrapper .wrapper .filter-dropdown.we-topic").find(".filter p").html(sel_length + " Topics Selected").css("color", "#000");
                        }
                    }

                    if (item[0] === "team") {
                        var numbersArray = item[1].split(',');
                        for (var j = 0; j < numbersArray.length; j++) {
                            var itemVal, selectedTxt;
                            itemVal = numbersArray[j];
                            $('.filters-block .filter-items .team li').each(function () {
                                var selectedItemVal;
                                var itemClass = $(this).attr("class");
                                selectedItemVal = $(this).attr("value");
                                if (itemClass != "selected") {
                                    if (itemVal === selectedItemVal) {
                                        $(this).addClass("selected");
                                        if ($('.filters-block.news').length > 0) {
                                            $(".views-exposed-form .form-item-field-research-team-target-id-verf select option[value=" + itemVal + "]").attr("selected", "selected");
                                        } else {
                                            $(".views-exposed-form .form-item-field-ref-group-target-id-verf select option[value=" + itemVal + "]").attr("selected", "selected");
                                        }

                                        $('.filters-block .selected-data').show();
                                        let filVal = $(this).clone().html();
                                        let filDataInx = $(this).attr("data-index");
                                        let filDataType = $(this).parent().attr("filter-data-type");
                                        let optionVal = $(this).attr("value");
                                        if (!$(this).parent().hasClass('alphabets-inner')) {
                                            $('.filters-block .filter-data .outer-wrapper').append('<span  filter-data-type = ' + filDataType + ' data-index =' + filDataInx + ' value =' + optionVal + '>' + filVal + '</span>');
                                            $('.filters-block .filter-data .outer-wrapper span').addClass('filter-tag');
                                        }

                                    }
                                }
                            });
                        }
                        var sel_length = $('.filters-block .filter-items .team li.selected').length;
                        if (sel_length > 0) {
                            $(".filters-block .filter-wrapper .wrapper .filter-dropdown.we-team").find(".filter p").html(sel_length + " Topics Selected").css("color", "#000");
                        }
                    }

                    if (item[0] === "news-type") {
                        var numbersArray = item[1].split(',');
                        for (var j = 0; j < numbersArray.length; j++) {
                            var itemVal, selectedTxt;
                            itemVal = numbersArray[j];
                            $('.filters-block .filter-dropdown.preference .news-press li').each(function () {
                                var selectedItemVal;
                                var itemClass = $(this).attr("class");
                                selectedItemVal = $(this).attr("value");
                                if (itemClass != "selected") {
                                    if (itemVal === selectedItemVal) {
                                        $(this).addClass("selected");
                                        $(".views-exposed-form .form-item-field-news-type-value select option[value=" + itemVal + "]").attr("selected", "selected");

                                        $('.filters-block .selected-data').show();
                                        let filVal = $(this).clone().html();
                                        let filDataInx = $(this).attr("data-index");
                                        let filDataType = $(this).parent().attr("filter-data-type");
                                        let optionVal = $(this).attr("value");
                                        if (!$(this).parent().hasClass('alphabets-inner')) {
                                            $('.filters-block .filter-data .outer-wrapper').append('<span  filter-data-type = ' + filDataType + ' data-index =' + filDataInx + ' value =' + optionVal + '>' + filVal + '</span>');
                                            $('.filters-block .filter-data .outer-wrapper span').addClass('filter-tag');
                                        }
                                    }
                                }
                            });
                        }
                    }

                    if (item[0] === "content-type") {
                        var numbersArray = item[1].split(',');
                        for (var j = 0; j < numbersArray.length; j++) {
                            var itemVal, selectedTxt;
                            itemVal = numbersArray[j];
                            $('.filters-block .filter-items .content-type li').each(function () {
                                var selectedItemVal;
                                var itemClass = $(this).attr("class");
                                selectedItemVal = $(this).attr("value");
                                if (itemClass != "selected") {
                                    if (itemVal === selectedItemVal) {
                                        $(this).addClass("selected");
                                        $("#views-exposed-form-all-research-block-1 .form-item-field-research-type-target-id select option[value=" + itemVal + "]").attr("selected", "selected");

                                        $('.filters-block .selected-data').show();
                                        let filVal = $(this).clone().html();
                                        let filDataInx = $(this).attr("data-index");
                                        let filDataType = $(this).parent().attr("filter-data-type");
                                        let optionVal = $(this).attr("value");
                                        if (!$(this).parent().hasClass('alphabets-inner')) {
                                            $('.filters-block .filter-data .outer-wrapper').append('<span  filter-data-type = ' + filDataType + ' data-index =' + filDataInx + ' value =' + optionVal + '>' + filVal + '</span>');
                                            $('.filters-block .filter-data .outer-wrapper span').addClass('filter-tag');
                                        }

                                    }
                                }
                            });
                        }
                        var sel_length = $('.filters-block .filter-items .content-type li.selected').length;
                        if (sel_length > 0) {
                            $(".filters-block .filter-wrapper .wrapper .filter-dropdown.we-content-type").find(".filter p").html(sel_length + " Topics Selected").css("color", "#000");
                        }
                    }

                    if (item[0] === "key-focus") {
                        var numbersArray = item[1].split(',');
                        for (var j = 0; j < numbersArray.length; j++) {
                            var itemVal, selectedTxt;
                            itemVal = numbersArray[j];
                            $('.filters-block .filter-items .key-focus li').each(function () {
                                var selectedItemVal;
                                var itemClass = $(this).attr("class");
                                selectedItemVal = $(this).attr("value");
                                if (itemClass != "selected") {
                                    if (itemVal === selectedItemVal) {
                                        $(this).addClass("selected");
                                        $("#views-exposed-form-all-research-block-1 .form-item-field-key-focus-areas-target-id select option[value=" + itemVal + "]").attr("selected", "selected");

                                        $('.filters-block .selected-data').show();
                                        let filVal = $(this).clone().html();
                                        let filDataInx = $(this).attr("data-index");
                                        let filDataType = $(this).parent().attr("filter-data-type");
                                        let optionVal = $(this).attr("value");
                                        if (!$(this).parent().hasClass('alphabets-inner')) {
                                            $('.filters-block .filter-data .outer-wrapper').append('<span  filter-data-type = ' + filDataType + ' data-index =' + filDataInx + ' value =' + optionVal + '>' + filVal + '</span>');
                                            $('.filters-block .filter-data .outer-wrapper span').addClass('filter-tag');
                                        }

                                    }
                                }
                            });
                        }
                        var sel_length = $('.filters-block .filter-items .key-focus li.selected').length;
                        if (sel_length > 0) {
                            $(".filters-block .filter-wrapper .wrapper .filter-dropdown.we-key-focus").find(".filter p").html(sel_length + " Topics Selected").css("color", "#000");
                        }
                    }

                    if (item[0] === "publication") {
                        var numbersArray = item[1].split(',');
                        for (var j = 0; j < numbersArray.length; j++) {
                            var itemVal, selectedTxt;
                            itemVal = numbersArray[j];
                            $('.filters-block .filter-items .publication li').each(function () {
                                var selectedItemVal;
                                var itemClass = $(this).attr("class");
                                selectedItemVal = $(this).attr("value");
                                if (itemClass != "selected") {
                                    if (itemVal === selectedItemVal) {
                                        $(this).addClass("selected");
                                        $("#views-exposed-form-all-research-block-1 .form-item-field-ref-publication-target-id-verf select option[value=" + itemVal + "]").attr("selected", "selected");

                                        $('.filters-block .selected-data').show();
                                        let filVal = $(this).clone().html();
                                        let filDataInx = $(this).attr("data-index");
                                        let filDataType = $(this).parent().attr("filter-data-type");
                                        let optionVal = $(this).attr("value");
                                        if (!$(this).parent().hasClass('alphabets-inner')) {
                                            $('.filters-block .filter-data .outer-wrapper').append('<span  filter-data-type = ' + filDataType + ' data-index =' + filDataInx + ' value =' + optionVal + '>' + filVal + '</span>');
                                            $('.filters-block .filter-data .outer-wrapper span').addClass('filter-tag');
                                        }

                                    }
                                }
                            });
                        }
                        var sel_length = $('.filters-block .filter-items .publication li.selected').length;
                        if (sel_length > 0) {
                            $(".filters-block .filter-wrapper .wrapper .filter-dropdown.we-publication").find(".filter p").html(sel_length + " Topics Selected").css("color", "#000");
                        }
                    }

                    if (item[0] === "region") {
                        var numbersArray = item[1].split(',');
                        for (var j = 0; j < numbersArray.length; j++) {
                            var itemVal, selectedTxt;
                            itemVal = numbersArray[j];
                            $('.filters-block .filter-items .region li').each(function () {
                                var selectedItemVal;
                                var itemClass = $(this).attr("class");
                                selectedItemVal = $(this).attr("value");
                                if (itemClass != "selected") {
                                    if (itemVal === selectedItemVal) {
                                        $(this).addClass("selected");
                                        $("#views-exposed-form-all-research-block-1 .form-item-field-tref-region-target-id select option[value=" + itemVal + "]").attr("selected", "selected");

                                        $('.filters-block .selected-data').show();
                                        let filVal = $(this).clone().html();
                                        let filDataInx = $(this).attr("data-index");
                                        let filDataType = $(this).parent().attr("filter-data-type");
                                        let optionVal = $(this).attr("value");
                                        if (!$(this).parent().hasClass('alphabets-inner')) {
                                            $('.filters-block .filter-data .outer-wrapper').append('<span  filter-data-type = ' + filDataType + ' data-index =' + filDataInx + ' value =' + optionVal + '>' + filVal + '</span>');
                                            $('.filters-block .filter-data .outer-wrapper span').addClass('filter-tag');
                                        }

                                    }
                                }
                            });
                        }
                        var sel_length = $('.filters-block .filter-items .region li.selected').length;
                        if (sel_length > 0) {
                            $(".filters-block .filter-wrapper .wrapper .filter-dropdown.we-region").find(".filter p").html(sel_length + " Topics Selected").css("color", "#000");
                        }
                    }

                    // Fellows Filter load trigger
                    // if (item[0] === "research-interest") {
                    //     var numbersArray = item[1].split(',');
                    //     for (var j = 0; j < numbersArray.length; j++) {
                    //         var itemVal;
                    //         itemVal = numbersArray[j];
                    //         $('.filters-block .filter-items .interest li').each(function () {
                    //             var selectedItemVal;
                    //             var itemClass = $(this).attr("class");
                    //             selectedItemVal = $(this).attr("value");
                    //             if (itemClass != "selected") {
                    //                 if (itemVal === selectedItemVal) {
                    //                     $(this).addClass("selected");
                    //                     $("#views-exposed-form-all-fellow-block-1 .form-item-field-tref-topic-target-id select option[value=" + itemVal + "]").attr("selected", "selected");

                    //                     $('.filters-block .selected-data').show();
                    //                     let filVal = $(this).clone().html();
                    //                     let filDataInx = $(this).attr("data-index");
                    //                     let filDataType = $(this).parent().attr("filter-data-type");
                    //                     let optionVal = $(this).attr("value");
                    //                     if (!$(this).parent().hasClass('alphabets-inner')) {
                    //                         $('.filters-block .filter-data .outer-wrapper').append('<span  filter-data-type = ' + filDataType + ' data-index =' + filDataInx + ' value =' + optionVal + '>' + filVal + '</span>');
                    //                         $('.filters-block .filter-data .outer-wrapper span').addClass('filter-tag');
                    //                     }

                    //                 }
                    //             }
                    //         });
                    //     }
                    //     var sel_length = $('.filters-block .filter-items .interest li.selected').length;
                    //     if (sel_length > 0) {
                    //         $(".filters-block .filter-wrapper .wrapper .filter-dropdown.we-interest").find(".filter p").html(sel_length + " Topics Selected").css("color", "#000");
                    //     }
                    // }

                    // if (item[0] === "expertise") {
                    //     var numbersArray = item[1].split(',');
                    //     for (var j = 0; j < numbersArray.length; j++) {
                    //         var itemVal;
                    //         itemVal = numbersArray[j];
                    //         $('.filters-block .filter-items .expertise li').each(function () {
                    //             var selectedItemVal;
                    //             var itemClass = $(this).attr("class");
                    //             selectedItemVal = $(this).attr("value");
                    //             if (itemClass != "selected") {
                    //                 if (itemVal === selectedItemVal) {
                    //                     $(this).addClass("selected");
                    //                     $("#views-exposed-form-all-fellow-block-1 .form-item-field-tref-expertise-target-id select option[value=" + itemVal + "]").attr("selected", "selected");

                    //                     $('.filters-block .selected-data').show();
                    //                     let filVal = $(this).clone().html();
                    //                     let filDataInx = $(this).attr("data-index");
                    //                     let filDataType = $(this).parent().attr("filter-data-type");
                    //                     let optionVal = $(this).attr("value");
                    //                     if (!$(this).parent().hasClass('alphabets-inner')) {
                    //                         $('.filters-block .filter-data .outer-wrapper').append('<span  filter-data-type = ' + filDataType + ' data-index =' + filDataInx + ' value =' + optionVal + '>' + filVal + '</span>');
                    //                         $('.filters-block .filter-data .outer-wrapper span').addClass('filter-tag');
                    //                     }

                    //                 }
                    //             }
                    //         });
                    //     }
                    //     var sel_length = $('.filters-block .filter-items .expertise li.selected').length;
                    //     if (sel_length > 0) {
                    //         $(".filters-block .filter-wrapper .wrapper .filter-dropdown.we-expertise").find(".filter p").html(sel_length + " Topics Selected").css("color", "#000");
                    //     }
                    // }

                    // if (item[0] === "fellow-type") {
                    //     var numbersArray = item[1].split(',');
                    //     for (var j = 0; j < numbersArray.length; j++) {
                    //         var itemVal;
                    //         itemVal = numbersArray[j];
                    //         $('.filters-block .filter-items .fellow-type li').each(function () {
                    //             var selectedItemVal;
                    //             var itemClass = $(this).attr("class");
                    //             selectedItemVal = $(this).attr("value");
                    //             if (itemClass != "selected") {
                    //                 if (itemVal === selectedItemVal) {
                    //                     $(this).addClass("selected");
                    //                     $("#views-exposed-form-all-fellow-block-1 .form-item-field-tref-fellow-type-target-id-1 select option[value=" + itemVal + "]").attr("selected", "selected");

                    //                     $('.filters-block .selected-data').show();
                    //                     let filVal = $(this).clone().html();
                    //                     let filDataInx = $(this).attr("data-index");
                    //                     let filDataType = $(this).parent().attr("filter-data-type");
                    //                     let optionVal = $(this).attr("value");
                    //                     if (!$(this).parent().hasClass('alphabets-inner')) {
                    //                         $('.filters-block .filter-data .outer-wrapper').append('<span  filter-data-type = ' + filDataType + ' data-index =' + filDataInx + ' value =' + optionVal + '>' + filVal + '</span>');
                    //                         $('.filters-block .filter-data .outer-wrapper span').addClass('filter-tag');
                    //                     }

                    //                 }
                    //             }
                    //         });
                    //     }
                    //     var sel_length = $('.filters-block .filter-items .fellow-type li.selected').length;
                    //     if (sel_length > 0) {
                    //         $(".filters-block .filter-wrapper .wrapper .filter-dropdown.we-type").find(".filter p").html(sel_length + " Topics Selected").css("color", "#000");
                    //     }
                    // }

                    if (!$('.filters-block.fellow').length > 0) {
                        if (item[0] === "search") {
                            var numbersArray = item[1].split(',');
                            for (var j = 0; j < numbersArray.length; j++) {
                                var itemVal;
                                itemVal = numbersArray[j];
                                if ($('.filters-block.fellow').length > 0) {
                                    $("#views-exposed-form-all-fellow-block-1 .form-item-combine input").val(itemVal);
                                } else {
                                    $("#views-exposed-form-all-research-block-1 .form-item-combine input").val(itemVal);
                                }
                                $(".filters-block .filter-dropdown.search input").val(itemVal);
                            }
                        }
                    }

                    if (item[0]) {
                        if (i === array.length - 1) {
                            var staticWid1 = $('.filters-block .filter-data').width() - 60;
                            var dataLen1 = $('.filters-block .filter-data .outer-wrapper span').length;
                            var dataWidth1 = $('.filters-block .filter-data .outer-wrapper').width();
                            if (staticWid1 <= dataWidth1) {
                                if (dataLen1 > 1) {
                                    $('.filters-block .filter-data .total-data').html('<span>' + "+" + dataLen1 + '</span>');
                                }
                                $(".filters-block .filter-data .outer-wrapper").css('width', staticWid1 + "px");
                            }
                            else {
                                $(".filters-block .filter-data .outer-wrapper").css('width', 'initial');
                                $('.filters-block .filter-data .total-data').html('');
                            }

                            // Show clear btn
                            if (dataLen1 > 0) {
                                $('.filters-block .filter-wrapper .filter-content .filter-title span').removeAttr('style');
                                $('.filters-block .filter-wrapper .filter-bar .filter-title span').removeAttr('style');
                                $('.filters-block.fellow .selected-data .filter-title span').removeAttr('style');
                            }

                            //dataDel($('.filters-block .filter-data .outer-wrapper span'));
                            $(".filters-block .form-actions .form-submit").trigger("click");
                        }
                    }

                }

            }

            // Push value in array
            function listValue() {
                var topic_arr = [], team_arr = [], news_arr = [];
                var interest_arr = [], exper_arr = [], fellow_type_arr = [], search_arr = [];
                var content_type_arr = [], key_focus_arr = [], publication_arr = [], region_arr = [];
                if (!$('.filters-block.fellow').length > 0 && !$('.filter-block.algolia-research')) {
                    $('.filters-block .filter-items .topic').find('li.selected').each(function () {
                        var listVal = $(this).attr("value");
                        topic_arr.push(listVal);
                    });

                    $('.filters-block .filter-items .team').find('li.selected').each(function () {
                        var listVal = $(this).attr("value");
                        team_arr.push(listVal);
                    });

                    $('.filters-block .filter-dropdown .news-press').find('li.selected').each(function () {
                        var listVal = $(this).attr("value");
                        news_arr.push(listVal);
                    });

                    $('.filters-block .filter-items .content-type').find('li.selected').each(function () {
                        var listVal = $(this).attr("value");
                        content_type_arr.push(listVal);
                    });

                    $('.filters-block .filter-items .key-focus').find('li.selected').each(function () {
                        var listVal = $(this).attr("value");
                        key_focus_arr.push(listVal);
                    });

                    $('.filters-block .filter-dropdown .publication').find('li.selected').each(function () {
                        var listVal = $(this).attr("value");
                        publication_arr.push(listVal);
                    });

                    $('.filters-block .filter-dropdown .region').find('li.selected').each(function () {
                        var listVal = $(this).attr("value");
                        region_arr.push(listVal);
                    });
                }

                // if ($(".filters-block.news").length > 0 || $(".filters-block.research").length > 0) {
                //   var date = $('.daterangepicker .drp-selected').text();
                //   let text = ""+date+"";
                //   const trimDate = text.replace(/ /g, "");
                //   date_arr.push(trimDate);
                // }

                // if ($('.filters-block.fellow').length > 0) {
                //     $('.filters-block .filter-dropdown .interest').find('li.selected').each(function () {
                //         var listVal = $(this).attr("value");
                //         interest_arr.push(listVal);
                //     });

                //     $('.filters-block .filter-dropdown .expertise').find('li.selected').each(function () {
                //         var listVal = $(this).attr("value");
                //         exper_arr.push(listVal);
                //     });

                //     $('.filters-block .filter-dropdown .fellow-type').find('li.selected').each(function () {
                //         var listVal = $(this).attr("value");
                //         fellow_type_arr.push(listVal);
                //     });
                // }

                $('.filters-block .filter-dropdown.search').find('input').each(function () {
                    var listVal = $(this).val();
                    search_arr.push(listVal);
                });

                if ($('.filters-block.news').length > 0) {
                    //urlUpdate("team=" + team_arr + "$topic=" + topic_arr + "$news-type=" + news_arr + "");
                }
                // if ($('.filters-block.fellow').length > 0) {
                //     urlUpdate("research-interest=" + interest_arr + "$expertise=" + exper_arr + "$fellow-type=" + fellow_type_arr + "$search=" + search_arr + "");
                // }
                if ($('.filters-block.research').length > 0 && !$('.filter-block.algolia-research')) {
                    //urlUpdate("team=" + team_arr + "$topic=" + topic_arr + "$content-type=" + content_type_arr + "$key-focus=" + key_focus_arr + "$publication=" + publication_arr + "$region=" + region_arr + "$search=" + search_arr + "");
                }
            }

            // Code for update value in address bar EOD

            $(window).on('load', function () {
                setTimeout(function () {
                    //fetchUrl();
                }, 500);
            });

            $('.filters-block .filter-dropdown.search input').on('keyup', function () {
                if ($('.filters-block').length > 0 && !$(".filters-block.fellow").length > 0) {
                    //removeUrl();
                    listValue();
                }
            });

            $(".filters-block .filter-dropdown.search input").on("keyup", function () {
                var inputValue = $(this).val();
                if (inputValue) {
                    $(this).parent().find('label').addClass("hide");
                }
                else {
                    $(this).parent().find('label').removeClass("hide");
                }
            });

            //filter tag selection
            $('.filters-block .filter-wrapper .filter-dropdown li').on('click', function () {
                if (!$(this).hasClass("selected")) {
                    $(this).addClass('selected');
                    $('.filters-block .selected-data').show();
                    let filVal = $(this).clone().html();
                    let filDataInx = $(this).attr("data-index");
                    let filDataType = $(this).parent().attr("filter-data-type");
                    let optionVal = $(this).attr("value");

                    if ($('.filters-block').length > 0 && !$(".filters-block.fellow").length > 0) {
                        //removeUrl();
                        listValue();
                    }

                    if (!$(this).parent().hasClass('alphabets-inner')) {
                        $('.filters-block .filter-data .outer-wrapper').append('<span  filter-data-type = ' + filDataType + ' data-index =' + filDataInx + ' value =' + optionVal + '>' + filVal + '</span>');
                        $('.filters-block .filter-data .outer-wrapper span').addClass('filter-tag');
                    }
                    var dataLen = $('.filters-block .filter-data .outer-wrapper span').length;
                    var dataWidth = $('.filters-block .filter-data .outer-wrapper').width();

                    $(this).parents('.filter-wrapper').find('.filter-title span').show();
                    const staticWid1 = $('.filters-block .filter-data').width();
                    const staticWid2 = staticWid1 - 64;
                    if (staticWid2 <= dataWidth) {
                        if (dataLen > 1) {
                            $('.filters-block .filter-data .total-data').html('<span>' + "+" + dataLen + '</span>');
                        }
                        $(".filters-block .filter-data .outer-wrapper").css('width', staticWid + "px");
                    }

                    else {
                        $(".filters-block .filter-data .outer-wrapper").css('width', 'initial');
                        $('.filters-block .filter-data .total-data').html('');
                    }
                    if (dataLen >= 1) {
                        //dataDel($('.filters-block .filter-data .outer-wrapper span'));
                    }

                    if ($(".filters-block .outer-wrapper").hasClass("slick-initialized")) {
                        if (!$(this).parent().hasClass('alphabets-inner')) {
                            $('.filters-block .filter-data .outer-wrapper .slick-list .slick-track').append('<span  filter-data-type = ' + filDataType + ' data-index =' + filDataInx + ' value =' + optionVal + '>' + filVal + '</span>');
                        }
                        $('.filters-block .filter-data .total-data').html(' ');
                    }
                    $('.filters-block .pagination input').val(1);
                }
                else {
                    $(this).removeClass('selected');

                    if ($('.filters-block').length > 0 && !$(".filters-block.fellow").length > 0) {
                        //removeUrl();
                        listValue();
                    }

                    let delValInx = 0;
                    const selValInx = $(this).attr("data-index");
                    $(".filters-block .filter-data .outer-wrapper span").each(function (i) {
                        delValInx = $(this).attr("data-index");
                        if (selValInx == delValInx) {
                            $(this).attr("data-index", selValInx).remove();
                        }
                        if ($('.filters-block .filter-data .outer-wrapper span').length <= 0) {
                            $('.filters-block .selected-data').hide();
                            $('.filters-block .filter-title span').hide();
                        }
                        var dataLen = $('.filters-block .filter-data .outer-wrapper span').length;
                        var we_staticWid = $('.filters-block .selected-data .filter-data').width();
                        const staticWid3 = we_staticWid - 64;
                        const dataWidth2 = $('.filters-block .filter-data .outer-wrapper').width();
                        $(".filters-block .filter-data .outer-wrapper").css('width', 'initial');
                        if (staticWid3 >= dataWidth2) {
                            $('.filters-block .filter-data .total-data').html('<span class="reset">' + "+" + dataLen + '</span>');
                        }
                        $('.filters-block .filter-data .total-data').html('<span class="reset">' + "+" + dataLen + '</span>');
                        if (dataWidth2 + 50 < $('.filters-block .filter-data').width() - 60) {
                            $('.filters-block .filter-data .total-data').html('');
                        }

                    });
                    $('.filters-block .pagination input').val(1);
                }
            });

            // Clear All
            $('.filters-block .filter-wrapper .filter-title > span').on('click', function () {
                if ($('.filters-block').length > 0 && !$(".filters-block.fellow").length > 0) {
                    //removeUrl();
                }
                $(".filters-block .total-data").empty();
                $(".filters-block .filter-dropdown.search input").val(' ');
                $("#views-exposed-form-all-research-block-1 .form-item-combine input").val(' ');
                $("#views-exposed-form-all-fellow-block-1 .form-item-combine input").val(' ');

                $('.filters-block .filter-dropdown li').each(function () {
                    $(this).removeClass('selected');
                });
                $(".filter p").html("Select from the list...").css("color", "#B9B9B9");
                $('.filters-block .filter-data .outer-wrapper').empty();
                $(".filters-block .filter-data .outer-wrapper").css('width', 'initial');
                $('.filters-block .selected-data').hide();
                $('.filters-block .filter-wrapper .filter-title span').hide();
                $(".filters-block .edit-filter").removeClass("edit");
                $('.filter-content').show();
                if ($(".filters-block .outer-wrapper").hasClass("slick-initialized")) {
                    $(".filters-block .outer-wrapper").slick('unslick').removeClass("show-all").html(" ");
                }
                $.each($(".filters-block .form-select option"), function () {
                    let anyTxt = $(this).attr("value");
                    $(this).removeAttr("selected");
                    if (anyTxt == "All") {
                        $(this).attr("selected");
                    }
                });
                $(".daterangepicker .drp-buttons .cancelBtn").trigger("click");
                $(".filters-block .form-actions .form-submit").trigger("click");
                $('.filters-block .pagination input').val(1);
            });

            $('.filters-block .result--wrapper .grid-view').on('click', function () {
                $(this).siblings().removeClass('selected');
                $(this).addClass('selected');
                $('.filters-block .column-wrapper').addClass('view-grid');
                if ($('.filters-block').hasClass('hoover-press')) {

                    var thisSec = $('.filters-block ');
                    setLines(thisSec);

                }
            });
            $('.filters-block .result--wrapper .list-view').on('click', function () {
                $(this).siblings().removeClass('selected');
                $(this).addClass('selected');
                $('.filters-block .column-wrapper').removeClass('view-grid');
                if ($('.filters-block').hasClass('hoover-press')) {
                    var thisSec = $('.filters-block ');
                    setLines(thisSec);
                }
            });
            $('.filters-block .result--wrapper .sort-view').on('click', function () {
                $(this).toggleClass('active');
            });
            $('.filters-block .result--wrapper .sort-view li').on('click', function () {
                $(this).siblings().removeClass('selected');
                $(this).addClass('selected');
                $(this).parent().removeClass('active');
                $('.sort-view').find('p span').text($(this).find('span').text());
            });
            $(".filters-block .total-data").on("click", function () {

                $(this).siblings().slick({
                    variableWidth: true,
                    infinite: false,
                });
                $(this).html(" ");

            });

            if ($(".filters-block.news").length > 0 || $(".filters-block.research").length > 0) {

                $('.filter input[name="daterange"]').daterangepicker({
                    opens: 'left',
                    locale: {
                        cancelLabel: 'Clear'
                    },
                }, function (start, end, label) {
                    var st = start.format("YYYY-MM-DD");
                    var ed = end.format("YYYY-MM-DD");
                    var stNew = start.format("MM/DD/YYYY");
                    var edMew = end.format("MM/DD/YYYY");
                    if ($("#date").length > 0) {
                        const stDate = new Date(stNew).getTime();
                        const STtimestamp = stDate / 1000;
                        const dtDate = new Date(edMew).getTime();
                        const EDTtimestamp = dtDate / 1000;
                        $("#date #mindaterange").val(STtimestamp);
                        $("#date #maxdaterange").val(EDTtimestamp);
                        $("#date #submitdateform").trigger('click');
                    }
                    // News Date Filter
                    $(".filters-block .form-item-field-news-date-value-min input").val(st);
                    $(".filters-block .form-item-field-news-date-value-max input").val(ed);

                    // ResearchDate Filter
                    $(".filters-block .form-item-field-research-date-value-min input").val(st);
                    $(".filters-block .form-item-field-research-date-value-max input").val(ed);

                    // Event Page
                    $(".filters-block .form-item-field-date-value-1-min input").val(st);
                    $(".filters-block .form-item-field-date-value-1-max input").val(ed);
                    $(".filters-block .form-actions .form-submit").trigger("click");

                });

                $('.filter input[name="daterange"]').on('cancel.daterangepicker', function (ev, picker) {

                    // $(this).data('daterangepicker').setStartDate(moment().format("MM-DD-YYYY")); //date now
                    // $(this).data('daterangepicker').setEndDate(moment().format("MM-DD-YYYY"));//date now

                    $(this).val('').attr("placeholder", "From - To");

                    $(".filters-block .form-item-field-news-date-value-min input").val(" ");
                    $(".filters-block .form-item-field-news-date-value-max input").val(" ");

                    // ResearchDate Filter
                    $(".filters-block .form-item-field-research-date-value-min input").val(" ");
                    $(".filters-block .form-item-field-research-date-value-max input").val(" ");

                    // Event Page
                    $(".filters-block .form-item-field-date-value-1-min input").val(" ");
                    $(".filters-block .form-item-field-date-value-1-max input").val(" ");

                    $(".filters-block .form-actions .form-submit").trigger("click");
                });

                $('.filter [name="daterange"]').val('');
                $('.filter [name="daterange"]').attr("placeholder", "From - To");

                $('.filters-block .wrapper .filter-dropdown.date form').on('submit', function (event) {
                    event.preventDefault();
                });
            }

            $('.filters-block').css("opacity", "1");
            $('.filters-block.fellow .filter-results .show-result .sort-by span:first-child').addClass('active');

            //**************by default one li selected ******************//


            $('.filters-block .filter-wrapper .filter-dropdown li.selected').each(function () {
                if ($(this).length > 0) {
                    let filVal = $(this).clone().html();
                    let filDataInx = $(this).attr("data-index");
                    let filDataType = $(this).parent().attr("filter-data-type");
                    let optionVal = $(this).attr("value");
                    $('.filters-block .filter-data .outer-wrapper').append('<span  filter-data-type = ' + filDataType + ' data-index =' + filDataInx + ' value =' + optionVal + ' class =' + 'filter-tag' + '>' + filVal + '</span>');
                    $('.filters-block .selected-data').show();
                    //dataDel($('.filters-block .filter-data .outer-wrapper span'));
                }
            });

        }
        //accordian code starts here
        $('.algolia-fellow .filter-results #hits .ais-Hits-list .ais-Hits-item:lt(2) .fellow-result').find('.fellow-card-wrapper').slideDown();
        $('.algolia-fellow .filter-results #hits .ais-Hits-list .ais-Hits-item:lt(2) .fellow-title').addClass('minus');
        // $('.algolia-fellow .filter-results .fellow-result .fellow-title').on('click', function () {
        //     $(this).next('.fellow-card-wrapper').slideToggle();
        //     $(this).toggleClass('minus');
        // });
        var div_width = $('.filters-block.fellow .filter-wrapper .wrapper').width();
        $('.filters-block.fellow .filter-wrapper .wrapper .filter-dropdown .filter-items').css({ 'width': +div_width });

        $('.filters-block .filter-results .fellow-result .fellow-card-wrapper .fellow-card').matchHeight();

        //*********** click to on tags to make them carousel ***************

        $('.filters-block.fellow .filter-data .total-data').on('click', function () {
            $(this).parent().find('.outer-wrapper').not('.slick-initialized').slick({
                infinite: false,
                slidesToShow: 7,
                slideToScroll: 1,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                        }
                    },

                ]

            });
            $(this).hide();
        });


        //btn-wrap click code for fellow template*************

        $('.filters-block .filter-wrapper .filter-content .btn-wrap').on('click', '.link-more', function () {
            if ($(this).parent().hasClass('less')) {
                $(this).parent().removeClass('less');
                $(this).find('span').text('Additional Filters');
            } else {
                $(this).parent().addClass('less');
                $(this).find('span').text('Collapse Filters');
            }
            //$(this).parents('.filter-wrapper').find('.filter-dropdown').siblings('.filter-dropdown.toggleable').slideToggle();
            var filter_dropdown = $(this).parents('.filter-wrapper').find('.filter-dropdown');
            var count = 0;
            filter_dropdown.each(function () {
                if (!$(this).hasClass("hide")) {
                    count = count + 1;
                    const index = $(this).index();
                    if (count > 3) {
                        $(this).slideToggle();
                    }
                }
            });


        });
        $('.filters-block .filter-results .fellow-result .fellow-card-wrapper .btn-wrap').on('click', '.link-more', function () {
            if ($(this).parent().hasClass('less')) {
                $(this).parent().removeClass('less');
                $(this).find('span').text('View More');
            } else {
                $(this).parent().addClass('less');
                $(this).find('span').text('View Less');
            }
        });


        //********click to scroll upto the filters*******

        $('body .filters-block .filter-wrapper .edit-filter').on('click', function () {

            var minusHgt = $('header').outerHeight() + $('.sticky-nav').outerHeight() - 5;
            setTimeout(function () {
                if ($('header').hasClass('off-canvas')) {
                    $('html, body').animate({
                        scrollTop: $('.filters-block').offset().top - minusHgt
                    }, 500);
                }
                else {
                    $('html, body').animate({
                        scrollTop: $('.filters-block').offset().top - 160
                    }, 500);
                }
            }, 500);

            if ($(this).css('position') === 'fixed') {
                $(this).removeClass('edit');
                $('.filters-block .filter-wrapper .filter-content').show();
                $('.filters-block .filter-wrapper .btn-wrap').addClass('less');
                $('.filters-block .filter-wrapper .btn-wrap').find('.link-more span').text('Collapse Filters');
                //}
                $('.filters-block .filter-wrapper .filter-content .wrapper .filter-dropdown.toggleable').slideDown();
            }
        });

        if ($('.filters-block').hasClass('hoover-press')) {
            $('.daterangepicker').addClass('hoover-press');
        }

        // No-image full content
        // $('.filters-block .column-wrapper .col-three').each(function () {
        //     if ($(this).find('.bg-img').length === 0) {
        //         $(this).find('.content').css('width' , '100%');
        //     }
        // });

        $(".filters-block #global-fellow-search input").keyup(function () {
            var $val = $(this).val();
            if ($val.length > 0) {
                $(this).parent().find(".search-reset").css({ opacity: "1" });
            } else {
                $(this).parent().find(".search-reset").css({ opacity: "0" });
            }
        });

        $(".filters-block #global-fellow-search .search-reset").on("click", function (e) {
            $(".filters-block #global-fellow-search input").val('');
            $(".filters-block #global-fellow-search .search-reset").css({ opacity: "0" });
        });

    });

    $(window).on('resize orientationchange', function () {
        if ($('.filters-block').hasClass('hoover-press')) {
            var thisSec = $('.filters-block ');
            setLines(thisSec);
        }
    });

    $(window).resize(function () {
        if ($('.filters-block').length > 0) {
            if ($('body .filters-block .filter-wrapper .edit-filter').css('position') != 'absolute') {
                var off_left = $('.container').offset().left;
                var edit_wid = $('body .filters-block .filter-wrapper .edit-filter').width();
                var total = (off_left - edit_wid) + 20;
                $('body .filters-block .filter-wrapper .edit-filter').css({
                    'left': +total,
                });
                if ($(window).width() < 1400 && $(window).width() > 1330) {
                    var off_left1 = $('body .header .nav-logo').offset().left;
                    var total1 = (off_left1 + edit_wid) - 40;
                    $('body .filters-block .filter-wrapper .edit-filter').css({
                        'left': +total1,
                    });
                }
                if ($(window).width() < 1329 && $(window).width() > 1270) {
                    var off_left2 = $('body .header .nav-logo').offset().left;
                    var total2 = (edit_wid - off_left2) - 10;

                    $('body .filters-block .filter-wrapper .edit-filter').css({
                        'left': +total2,
                    });
                }
                if ($(window).width() < 1270 && $(window).width() > 1200) {
                    var off_left3 = $('body .header .nav-logo').offset().left;
                    var total3 = (off_left3 - edit_wid) + 10;

                    $('body .filters-block .filter-wrapper .edit-filter').css({
                        'left': +total3,
                    });
                }
            }
        }
    });

    if ($('.filters-block .edit-filter').length > 0) {
        var off_top = $('body .filters-block .filter-wrapper').offset().top + $('.fellow-slider').height();
        if ($('body .header .nav-logo').length) {
            var off_left = $('body .header .nav-logo').offset().left;
        }

        // $(window).on('scroll', function () {
        //     var edit_wid = $('body .filters-block.fellow .filter-wrapper .edit-filter').width();
        //     var total = (off_left - edit_wid);
        //     if ($('.filters-block').next().length > 0) {
        //         var sec_hgt = $('.filters-block').next().offset().top - $('.filters-block').next().height() - 100;
        //     }

        //     var win_scroll = $(window).scrollTop();
        //     console.log(off_top)
        //     if (win_scroll >= off_top) {
        //         $('body .filters-block.fellow .filter-wrapper .edit-filter').css({
        //             'position': 'fixed',
        //             'left': +total,
        //             'top': '146px'
        //         });
        //         if (win_scroll >= sec_hgt) {
        //             $('body .filters-block.fellow .filter-wrapper .edit-filter').css({
        //                 'position': 'absolute',
        //                 'left': '-65px',
        //                 'top': 'unset',
        //                 'bottom': '0'
        //             });
        //             if ($(window).width() < 1600) {
        //                 $('body .filters-block.fellow .filter-wrapper .edit-filter').css({
        //                     'position': 'absolute',
        //                     'left': '-49px',
        //                     'top': 'unset',
        //                     'bottom': '0'
        //                 });
        //             }
        //         }
        //         if ($('header').hasClass('off-canvas')) {
        //             $('body .filters-block.fellow .filter-wrapper .edit-filter').css({
        //                 'top': '206px'
        //             });
        //         }
        //     }
        //     else {
        //         $('body .filters-block.fellow .filter-wrapper .edit-filter').css({
        //             'position': 'absolute',
        //             'left': '-65px',
        //             'top': '0',
        //             'bottom': 'unset'
        //         });
        //         if ($(window).width() < 1600) {
        //             $('body .filters-block.fellow .filter-wrapper .edit-filter').css({
        //                 'position': 'absolute',
        //                 'left': '-49px',
        //                 'top': '0',
        //                 'bottom': 'unset'
        //             });
        //         }
        //     }
        // })

    }

    function setLines(thisSec) {
        var thisSec = thisSec;
        thisSec.find('.col-three').each(function () {
            if ($(this).hasClass('three-lines')) {
                $(this).removeClass('three-lines');
            }
            else if ($(this).hasClass('two-lines')) {
                $(this).removeClass('two-lines');
            }
            else if ($(this).hasClass('one-line')) {
                $(this).removeClass('one-line');
            }
            var titleHeight = $(this).find('h6').outerHeight();
            var titleFontSize = $(this).find('h6').css('font-size');
            titleFontSize = parseInt(titleFontSize);
            var titleNumLines = parseInt(titleHeight / titleFontSize);

            if (titleNumLines >= 3) {
                $(this).addClass('three-lines');
            }
            else if (titleNumLines == 2) {
                $(this).addClass('two-lines');
            }
            else if (titleNumLines == 1) {
                $(this).addClass('one-line');
            }

        });
    }

    // Filter tracking
    document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll('.filter-dropdown').forEach(function (element) {
            element.addEventListener('click', function () {
                gtag('event', 'filter_dropdown_click', {
                    'dropdown_class': element.className,  // Sends the class of the clicked element
                    'page_url': window.location.href      // Sends the current page URL
                });
            });
        });
    });

    //sroll to section when click from map

    const researchSection = document.querySelector(".filters-block.algolia-research")
    const urlParameters = window.location.search
    if (urlParameters.includes("region")) {
        let fromTop = researchSection.getBoundingClientRect().top
        window.scrollTo({ top: fromTop, behavior: 'smooth' });
    }
})
    (jQuery);
